module.exports = __webpack_public_path__ + "img/2.17147a1e.svg";